"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_1050 = exports.Plan_1049 = exports.Plan_1048 = exports.Plan_1047 = exports.Plan_1046 = exports.Plan_1045 = exports.Plan_1044 = exports.Plan_1042 = exports.Plan_1040 = exports.Plan_1039 = exports.Plan_1038 = exports.Plan_1037 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_1042 = exports.Plan_1042 = {
  planNumber: 1042,
  kindOfCover: "Comprehensive",
  externalName: "Nose-to-Tail Cover",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$20,000",
  petSpecies: [],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4172",
    "excessNo": 4172
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4174",
    "excessNo": 4174
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4175",
    "excessNo": 4175
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4177",
    "excessNo": 4177
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4178",
    "excessNo": 4178
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4179",
    "excessNo": 4179
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4181",
    "excessNo": 4181
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4182",
    "excessNo": 4182
  }],
  levelsOfCover: [70, 80, 90],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 0,
      "maxAgeDays": 3287,
      "displayValue": "Younger than 9 years"
    },
    "annualLimit": {
      "amount": 20000,
      "formattedAmount": "$20,000",
      "displayValue": "$20,000"
    },
    "emergencyBoardingFees": "$20,000"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "2 days",
          "label": "specified accidental injuries"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "afterLifeCare": false,
    "alprazolam": false,
    "amitriptyline": false,
    "behaviouralAssessment": false,
    "behaviouralTherapy": false,
    "councilRegistration": false,
    "desexing": false,
    "essentialEuthanasia": false,
    "fleaControlDrugs": false,
    "fleaTickControlDrugs": false,
    "fleaWormDrugs": false,
    "heartWormDrugs": false,
    "intestinalWormDrugs": false,
    "jointSupplements": false,
    "microchipping": false,
    "oralRinseDrugs": false,
    "prescriptionDiet": false,
    "routineTeethCleaning": false,
    "teethCleaningProducts": false,
    "vaccinationCat": false,
    "vaccinationDog": false,
    "coversIllness": true,
    "infectiousDisease": true,
    "toxicityPoisoning": true,
    "trichobezoar": true,
    "ingestionToxicity": true
  },
  isBasePlan: true,
  addOns: []
};
var Plan_1037 = exports.Plan_1037 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1037,
  emergencyBoardingFees: "$10,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4132",
    "excessNo": 4132
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4134",
    "excessNo": 4134
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4135",
    "excessNo": 4135
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4137",
    "excessNo": 4137
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4138",
    "excessNo": 4138
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4140",
    "excessNo": 4140
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4141",
    "excessNo": 4141
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 10000,
      formattedAmount: "$10,000",
      displayValue: "$10,000"
    }),
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$10,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  isVariant: true,
  basePlanNo: 1042,
  isBasePlan: false
});
var Plan_1038 = exports.Plan_1038 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1038,
  kindOfCover: "Comprehensive + Routine Care",
  externalName: "Nose-to-Tail Cover with Routine Care",
  routineCare: true,
  emergencyBoardingFees: "$10,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4142",
    "excessNo": 4142
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4144",
    "excessNo": 4144
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4145",
    "excessNo": 4145
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4147",
    "excessNo": 4147
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4148",
    "excessNo": 4148
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4150",
    "excessNo": 4150
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4151",
    "excessNo": 4151
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 10000,
      formattedAmount: "$10,000",
      displayValue: "$10,000"
    }),
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$10,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_1039 = exports.Plan_1039 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1039,
  kindOfCover: "Comprehensive + Dental/Alt/Behav",
  externalName: "Nose-to-Tail Cover with Booster Care",
  dental: true,
  emergencyBoardingFees: "$10,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4152",
    "excessNo": 4152
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4154",
    "excessNo": 4154
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4155",
    "excessNo": 4155
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4157",
    "excessNo": 4157
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4158",
    "excessNo": 4158
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4160",
    "excessNo": 4160
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4161",
    "excessNo": 4161
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 10000,
      formattedAmount: "$10,000",
      displayValue: "$10,000"
    }),
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$10,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "alternativeCare"],
  isBasePlan: false
});
var Plan_1040 = exports.Plan_1040 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1040,
  kindOfCover: "Comprehensive + Dental/Alt/Behav + Routine Ca",
  externalName: "Nose-to-Tail Cover with Booster Care and Routine Care",
  dental: true,
  routineCare: true,
  emergencyBoardingFees: "$10,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4162",
    "excessNo": 4162
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4164",
    "excessNo": 4164
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4165",
    "excessNo": 4165
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4167",
    "excessNo": 4167
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4168",
    "excessNo": 4168
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4170",
    "excessNo": 4170
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4171",
    "excessNo": 4171
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 10000,
      formattedAmount: "$10,000",
      displayValue: "$10,000"
    }),
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$10,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "No waiting period for routine care where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>No waiting period for routine care where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "routineCare", "alternativeCare"],
  isBasePlan: false
});
var Plan_1044 = exports.Plan_1044 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1044,
  kindOfCover: "Comprehensive + Routine Care",
  externalName: "Nose-to-Tail Cover with Routine Care",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4183",
    "excessNo": 4183
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4185",
    "excessNo": 4185
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4186",
    "excessNo": 4186
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4188",
    "excessNo": 4188
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4189",
    "excessNo": 4189
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4190",
    "excessNo": 4190
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4192",
    "excessNo": 4192
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4193",
    "excessNo": 4193
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_1045 = exports.Plan_1045 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1045,
  kindOfCover: "Comprehensive + Dental/Alt/Behav",
  externalName: "Nose-to-Tail Cover with Booster Care",
  dental: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4194",
    "excessNo": 4194
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4196",
    "excessNo": 4196
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4197",
    "excessNo": 4197
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4199",
    "excessNo": 4199
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4200",
    "excessNo": 4200
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4201",
    "excessNo": 4201
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4203",
    "excessNo": 4203
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4204",
    "excessNo": 4204
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "alternativeCare"],
  isBasePlan: false
});
var Plan_1046 = exports.Plan_1046 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1046,
  kindOfCover: "Comprehensive + Dental/Alt/Behav + Routine Ca",
  externalName: "Nose-to-Tail Cover with Booster Care and Routine Care",
  dental: true,
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4205",
    "excessNo": 4205
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4207",
    "excessNo": 4207
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4208",
    "excessNo": 4208
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4210",
    "excessNo": 4210
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4211",
    "excessNo": 4211
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4212",
    "excessNo": 4212
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4214",
    "excessNo": 4214
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4215",
    "excessNo": 4215
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "No waiting period for routine care where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>No waiting period for routine care where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "routineCare", "alternativeCare"],
  isBasePlan: false
});
var Plan_1047 = exports.Plan_1047 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1047,
  emergencyBoardingFees: "$30,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4216",
    "excessNo": 4216
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4218",
    "excessNo": 4218
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4219",
    "excessNo": 4219
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4221",
    "excessNo": 4221
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4222",
    "excessNo": 4222
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4223",
    "excessNo": 4223
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4225",
    "excessNo": 4225
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4226",
    "excessNo": 4226
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 30000,
      formattedAmount: "$30,000",
      displayValue: "$30,000"
    }),
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$30,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  isVariant: true,
  basePlanNo: 1042,
  isBasePlan: false
});
var Plan_1048 = exports.Plan_1048 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1048,
  kindOfCover: "Comprehensive + Routine Care",
  externalName: "Nose-to-Tail Cover with Routine Care",
  routineCare: true,
  emergencyBoardingFees: "$30,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4227",
    "excessNo": 4227
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4229",
    "excessNo": 4229
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4230",
    "excessNo": 4230
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4232",
    "excessNo": 4232
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4233",
    "excessNo": 4233
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4234",
    "excessNo": 4234
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4236",
    "excessNo": 4236
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4237",
    "excessNo": 4237
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 30000,
      formattedAmount: "$30,000",
      displayValue: "$30,000"
    }),
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$30,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_1049 = exports.Plan_1049 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1049,
  kindOfCover: "Comprehensive + Dental/Alt/Behav",
  externalName: "Nose-to-Tail Cover with Booster Care",
  dental: true,
  emergencyBoardingFees: "$30,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4238",
    "excessNo": 4238
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4240",
    "excessNo": 4240
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4241",
    "excessNo": 4241
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4243",
    "excessNo": 4243
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4244",
    "excessNo": 4244
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4245",
    "excessNo": 4245
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4247",
    "excessNo": 4247
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4248",
    "excessNo": 4248
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 30000,
      formattedAmount: "$30,000",
      displayValue: "$30,000"
    }),
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$30,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "alternativeCare"],
  isBasePlan: false
});
var Plan_1050 = exports.Plan_1050 = _objectSpread(_objectSpread({}, Plan_1042), {}, {
  planNumber: 1050,
  kindOfCover: "Comprehensive + Dental/Alt/Behav + Routine Ca",
  externalName: "Nose-to-Tail Cover with Booster Care and Routine Care",
  dental: true,
  routineCare: true,
  emergencyBoardingFees: "$30,000",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 70,
    "excessCode": "4249",
    "excessNo": 4249
  }, {
    "excess": 250,
    "levelOfCover": 70,
    "excessCode": "4251",
    "excessNo": 4251
  }, {
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "4252",
    "excessNo": 4252
  }, {
    "excess": 250,
    "levelOfCover": 80,
    "excessCode": "4254",
    "excessNo": 4254
  }, {
    "excess": 500,
    "levelOfCover": 80,
    "excessCode": "4255",
    "excessNo": 4255
  }, {
    "excess": 0,
    "levelOfCover": 90,
    "excessCode": "4256",
    "excessNo": 4256
  }, {
    "excess": 250,
    "levelOfCover": 90,
    "excessCode": "4258",
    "excessNo": 4258
  }, {
    "excess": 500,
    "levelOfCover": 90,
    "excessCode": "4259",
    "excessNo": 4259
  }],
  limits: _objectSpread(_objectSpread({}, Plan_1042.limits), {}, {
    annualLimit: _objectSpread(_objectSpread({}, Plan_1042.limits.annualLimit), {}, {
      amount: 30000,
      formattedAmount: "$30,000",
      displayValue: "$30,000"
    }),
    dentalCareLimit: "$2,000",
    dentalLimitBreakDown: undefined,
    emergencyBoardingFees: "$30,000",
    emergencyBoardingLimit: undefined,
    routineCareLimit: "$150",
    routineCareLimitBreakDown: [{
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 150
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 150
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 150
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 150
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 150
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 150
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 150
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 150
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 150
    }, {
      "description": "Nail Clipping",
      "code": "DG03065",
      "limit": 150
    }],
    alternativeCareLimit: "$2,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for general veterinary expenses.", "2 days for specified accidental injuries.", "No waiting period for emergency boarding.", "No waiting period for alternative care.", "6 months for dental illness treatments where selected.", "No waiting period for routine care where selected.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care.", "30 days for alternative care."],
      waitingPeriod: "30 days for general veterinary expenses.<br/>2 days for specified accidental injuries.<br/>No waiting period for emergency boarding.<br/>No waiting period for alternative care.<br/>6 months for dental illness treatments where selected.<br/>No waiting period for routine care where selected.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.<br/>30 days for alternative care.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_1042.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "6 months",
          "label": "dental illness treatments where selected"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  isVariant: true,
  basePlanNo: 1042,
  addOns: ["dental", "routineCare", "alternativeCare"],
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_1042: Plan_1042,
  Plan_1037: Plan_1037,
  Plan_1038: Plan_1038,
  Plan_1039: Plan_1039,
  Plan_1040: Plan_1040,
  Plan_1044: Plan_1044,
  Plan_1045: Plan_1045,
  Plan_1046: Plan_1046,
  Plan_1047: Plan_1047,
  Plan_1048: Plan_1048,
  Plan_1049: Plan_1049,
  Plan_1050: Plan_1050
};